var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerticalMenu = function SvgVerticalMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.002 17.507c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5M12.002 11.505c-.275 0-.5.225-.497.5 0 .275.225.5.5.5s.5-.225.5-.5-.225-.5-.503-.5M12.002 5.502c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5"
  })));
};
export { SvgVerticalMenu as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDU2NGY4NTkyOTRlYTFlNzViM2NlNDJhYjJlNGJhOTEuc3ZnIjs=";